import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Form,
  Spin,
  Card,
  // Tag,
  // Typography,
  Result as AntResult,
  Tabs,
  Button,
} from 'antd';
import { onError } from 'utils/handlers';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import {
  deletePadronConsiderado,
  getPadronesConsiderados,
  patchPadronConsiderado,
  postPadronConsiderado,
} from 'api/cuentaunicasir/padronesConsiderados';
import { getModelPermission, isAdmin } from 'utils/permission/index';
import { getCatalogoDePadrones, getContentTypesPadrones } from 'api/catalogos';
import TableAddConsiderado from 'components/TableAddConsiderado';
import { getAgencias } from 'api/empresas/agencias';
import { getAlcoholes } from 'api/empresas/alcoholes';
import { getArrendamientos } from 'api/empresas/arrendamientos';
import { getCasasDeEmpenio } from 'api/empresas/casasDeEmpenio';
import { getCedulas } from 'api/empresas/cedulas';
import { getHospedajes } from 'api/empresas/hospedajes';
import { getJuegosDeAzar } from 'api/empresas/juegosDeAzar';
import { getNotarios } from 'api/empresas/notarios';
import { getVehiculos } from 'api/recaudacion/vehiculos';
import { getEstadosDeVehiculo, getServiciosDelVehiculo, getTiposDeVehiculos } from 'api/recaudacion';
import { getConfiguracionDeClave, getTiposDeLlavesDePredios } from 'api/catastro';
import { getPredios } from 'api/catastro/predio';
import { useHistory } from 'react-router-dom';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import padronToString from 'utils/padronesToString';
import { useSelector } from 'react-redux';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { getEmpresas } from 'api/empresas/empresas';

const TABS = Object.freeze({
  EMPRESAS: 'EMPRESAS',
  AGENCIAS: 'AGENCIAS',
  ALCOHOLES: 'ALCOHOLES',
  ARRENDAMIENTO: 'ARRENDAMIENTO',
  CASASDEEMPENIO: 'CASASDEEMPENIO',
  CEDULAS: 'CEDULAS',
  HOSPEDAJES: 'HOSPEDAJES',
  JUEGOSDEAZAR: 'JUEGOSDEAZAR',
  NOTARIOS: 'NOTARIOS',
  PREDIOS: 'PREDIOS',
  VEHICULOS: 'VEHICULOS',
});

const baseColumns = [
  {
    titleText: 'Descripción',
    dataIndex: 'descripcion',
    key: 'descripcion',
    width: 300,
  },
];

const Considerados = ({ ciudadano }) => {
  const history = useHistory();
  const permission = useMemo(() => getModelPermission('padronconsiderado'), []);
  const empresasPermission = useMemo(() => getModelPermission('empresa'), []);
  const agenciaPermission = useMemo(() => getModelPermission('agencia'), []);
  const alcoholesPermission = useMemo(() => getModelPermission('alcohol'), []);
  const arrendamientoPermission = useMemo(() => getModelPermission('arrendamiento'), []);
  const casasDeEmpeniosPermission = useMemo(() => getModelPermission('casadeempenio'), []);
  const hospedajesPermission = useMemo(() => getModelPermission('hospedaje'), []);
  const cedulasPermission = useMemo(() => getModelPermission('cedular'), []);
  const juegosDeAzarPermission = useMemo(() => getModelPermission('juegodeazar'), []);
  const notariosPermission = useMemo(() => getModelPermission('notario'), []);
  const vehiculosPermission = useMemo(() => getModelPermission('vehiculo'), []);
  const prediosPermission = useMemo(() => getModelPermission('predio'), []);
  const hasPermissionClavesDePredios = isAdmin() ? getModelPermission('clavedepredio').view : false;
  const estados = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState(TABS.EMPRESAS);
  const [estadoDelVehiculo, setEstadoDelVehiculo] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [tiposDeVehiculos, setTiposDeVehiculos] = useState([]);
  const [prediosColumns, setprediosColumns] = useState([]);
  const [unidadesDeRecaudacion, setUnidadesDeRecaudacion] = useState([]);

  const [contentTypes, setContentTypes] = useState([]);

  const formatData = (_data, _contenTypes) => {
    const output = _data.map((e) => {
      const contentType = _contenTypes.find((c) => c.id === e.content_type);
      return {
        ...e,
        descripcion: padronToString(e?.datos_de_padron, contentType?.nivel),
      };
    });
    return output;
  };

  const fetchData = async () => {
    setLoading(true);
    if (ciudadano) {
      const _data = await getPadronesConsiderados({ ciudadano_considerado: ciudadano });
      setData(formatData(_data, contentTypes));
    }
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchRequirements = async () => {
      const _clavesDePredios = await getTiposDeLlavesDePredios();
      const llaves = await getConfiguracionDeClave({ estados_globales: 4 });
      if (llaves.some((e) => e.es_principal)) {
        setTimeout(() => {
          const _columns = baseColumns.concat(_clavesDePredios
            .filter((e) => llaves.some((a) => a.clave_de_predio === e.id))
            .map((e) => ({
              titleText: e.descripcion,
              dataIndex: e.clave,
              key: e.clave,
              width: 300,
            })));
          if (mounted) {
            setprediosColumns(_columns);
          }
        });
      }
    };
    const fetch = async () => {
      if (ciudadano) {
        setLoading(true);
        await getCatalogoDePadrones();
        const [
          _data,
          _estados,
          _servicios,
          _tipos,
          _recaudadoras,
          _contentTypes,
        ] = await Promise.all([
          getPadronesConsiderados({ ciudadano_considerado: ciudadano }),
          getEstadosDeVehiculo(),
          getServiciosDelVehiculo(),
          getTiposDeVehiculos(),
          getUnidadesDeRecaudacion(),
          getContentTypesPadrones(),
        ]);
        if (mounted) {
          setData(formatData(_data, _contentTypes));
          setEstadoDelVehiculo(_estados);
          setServicios(_servicios);
          setTiposDeVehiculos(_tipos);
          setUnidadesDeRecaudacion(_recaudadoras);
          setContentTypes(_contentTypes.map((e) => ({
            ...e,
            model: e.model.trim().toLowerCase()
              .replaceAll(' ', '_')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, ''),
          })));
          setLoading(false);
        }
      }
    };
    fetch();
    fetchRequirements();
    return () => { mounted = false; };
  }, [ciudadano]);

  const onCancel = () => {
    form.resetFields();
    setSelectedRowKeys([]);
    setVisible(false);
  };

  const onFinish = async (_continue = false, values = null) => {
    try {
      setLoading(true);
      await form.validateFields();
      const keys = Object.keys(values);
      const match = contentTypes.find((e) => e.model === keys[0]);
      const output = [];
      keys.forEach((k) => {
        values[k].forEach((e) => {
          output.push({
            padron_content_type: match.id,
            padron_object_id: e,
            ciudadano_considerado: ciudadano,
          });
        });
      });
      const [key] = selectedRowKeys;
      const _data = await (key ? patchPadronConsiderado(key, output)
        : postPadronConsiderado(output));
      if (_data) {
        await fetchData();
        if (_continue) {
          if (!key) {
            setSelectedRowKeys([_data.id]);
          }
        } else {
          onCancel();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deletePadronConsiderado(key);
    if (deleted) {
      setVisibleAlert(false);
      onCancel();
      await fetchData();
    }
    setLoading(false);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Padrón',
      key: 'padron_content_type',
      dataIndex: 'padron_content_type',
      width: 150,
      render: (text) => contentTypes.find((e) => e.id === text)?.model,
    },
    {
      titleText: 'Descripción',
      key: 'descripcion',
      dataIndex: 'descripcion',
      width: 300,
    },
    {
      titleText: 'Estado',
      key: 'estados_globales',
      dataIndex: 'estados_globales',
      width: 150,
      render: (text) => estados.find((e) => e.id === text)?.descripcion,
    },
    {
      titleText: 'Fecha de cancelación',
      key: 'fecha_de_cancelacion',
      dataIndex: 'fecha_de_cancelacion',
      width: 200,
      render: (text) => text?.format(DATE_FRONTEND_FORMAT),
    },
  ];

  const columnsEmpresa = [
    {
      titleText: 'Clave',
      key: 'clave',
      dataIndex: 'clave',
      width: 300,
    },
    {
      titleText: 'Nombre Comercial',
      key: 'nombre_comercial',
      dataIndex: 'nombre_comercial',
      width: 300,
    },

    {
      titleText: 'RFC',
      key: 'RFC',
      dataIndex: 'RFC',
      width: 300,
    },
  ];

  const columnsMultiple = [
    {
      titleText: 'Clave',
      key: 'clave',
      dataIndex: 'clave',
      width: 350,
    },
    {
      titleText: 'Descripcíon',
      key: 'descripcion',
      dataIndex: 'descripcion',
      width: 350,
    },
    {
      titleText: 'Unidad Recaudadora',
      dataIndex: 'unidad_recaudadora',
      key: 'unidad_recaudadora',
      width: 300,
      catalog: {
        cat: unidadesDeRecaudacion,
        labelProp: 'descripcion',
        use: false,
      },
    },
  ];

  const VehiculoColumns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 150,
    },
    {
      titleText: 'No. de Placa',
      dataIndex: 'numero_de_placa_vigente',
      key: 'numero_de_placa_vigente',
      width: 150,
    },
    {
      titleText: 'No. de Indentificación Vehícular',
      dataIndex: 'numero_de_identificacion_vehicular',
      key: 'numero_de_identificacion_vehicular',
      width: 250,
    },
    {
      titleText: 'Modelo del Vehículo',
      dataIndex: 'modelo',
      key: 'modelo',
      width: 200,
    },
    {
      titleText: 'Tarjeta de Circulación',
      dataIndex: 'tarjeta_de_circulacion',
      key: 'tarjeta_de_circulacion',
      width: 200,
    },
    {
      titleText: 'Clave de Repuve',
      dataIndex: 'clave_de_repuve',
      key: 'clave_de_repuve',
      width: 200,
    },
    {
      titleText: 'Servicio',
      dataIndex: 'servicio',
      key: 'servicio',
      width: 200,
      catalog: {
        cat: servicios,
        labelProp: 'nombre',
        use: true,
      },
    },
    {
      titleText: 'Estatus del Vehìculo',
      dataIndex: 'estatus_del_vehiculo',
      key: 'estatus_del_vehiculo',
      width: 200,
      catalog: {
        cat: estadoDelVehiculo,
        labelProp: 'nombre',
        use: true,
      },
    },
    {
      titleText: 'Tipo de Vehículo',
      dataIndex: 'tipo_de_vehiculo',
      key: 'tipo_de_vehiculo',
      width: 200,
      catalog: {
        cat: tiposDeVehiculos,
        labelProp: 'nombre',
        use: true,
      },
    },
  ];

  const getOnFinish = (values) => {
    onFinish(!selectedRowKeys?.length, values);
  };

  return (
    <Spin tip="Cargando..." spinning={loading}>
      {!visible ? (
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickDelete,
          }}
          allowSort={false}
          allowSearch={false}
          hasAllViewPermission
          permission={permission}
          rowKey="id"
          mobileColIndex={0}
        />
      ) : (
        <Card
          bordered={false}
          title={(
            <FormSubmitControls
              label="Agregar"
              onCancel={onCancel}
            />
          )}
        >
          <Tabs
            type="card"
            onChange={setCurrentTabKey}
            activeKey={currentTabKey}
            defaultActiveKey={TABS.EMPRESAS}
          >
            {empresasPermission?.view && (
              <Tabs.TabPane tab="Empresas" key={TABS.EMPRESAS} forceRender>
                <TableAddConsiderado
                  get={getEmpresas}
                  callback={getOnFinish}
                  permission={empresasPermission}
                  propName="empresa"
                  columns={columnsEmpresa}
                  ciudadano={ciudadano}
                  filterProp="ciudadano"
                />
              </Tabs.TabPane>
            )}
            {agenciaPermission?.view && (
              <Tabs.TabPane tab="Agencias" key={TABS.AGENCIAS} forceRender>
                <TableAddConsiderado
                  get={getAgencias}
                  callback={getOnFinish}
                  permission={empresasPermission}
                  propName="agencia"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {alcoholesPermission?.view && (
              <Tabs.TabPane tab="Alcoholes" key={TABS.ALCOHOLES} forceRender>
                <TableAddConsiderado
                  get={getAlcoholes}
                  callback={getOnFinish}
                  permission={alcoholesPermission}
                  propName="alcohol"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {arrendamientoPermission?.view && (
              <Tabs.TabPane tab="Arrendamientos" key={TABS.ARRENDAMIENTO} forceRender>
                <TableAddConsiderado
                  get={getArrendamientos}
                  callback={getOnFinish}
                  permission={arrendamientoPermission}
                  propName="arrendamiento"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {casasDeEmpeniosPermission?.view && (
              <Tabs.TabPane tab="Casas de Empeño" key={TABS.CASASDEEMPENIO} forceRender>
                <TableAddConsiderado
                  get={getCasasDeEmpenio}
                  callback={getOnFinish}
                  permission={casasDeEmpeniosPermission}
                  propName="casa_de_empeno"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {cedulasPermission?.view && (
              <Tabs.TabPane tab="Cédulas" key={TABS.CEDULAS} forceRender>
                <TableAddConsiderado
                  get={getCedulas}
                  callback={getOnFinish}
                  permission={cedulasPermission}
                  propName="cedular"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {hospedajesPermission?.view && (
              <Tabs.TabPane tab="Hospedajes" key={TABS.HOSPEDAJES} forceRender>
                <TableAddConsiderado
                  get={getHospedajes}
                  callback={getOnFinish}
                  permission={hospedajesPermission}
                  propName="hospedaje"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {juegosDeAzarPermission?.view && (
              <Tabs.TabPane tab="Juegos de Azar" key={TABS.JUEGOSDEAZAR} forceRender>
                <TableAddConsiderado
                  get={getJuegosDeAzar}
                  callback={getOnFinish}
                  permission={juegosDeAzarPermission}
                  propName="juego_de_azar"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {notariosPermission?.view && (
              <Tabs.TabPane tab="Notarios" key={TABS.NOTARIOS} forceRender>
                <TableAddConsiderado
                  get={getNotarios}
                  callback={getOnFinish}
                  permission={notariosPermission}
                  propName="notario"
                  columns={columnsMultiple}
                  ciudadano={ciudadano}
                />
              </Tabs.TabPane>
            )}
            {vehiculosPermission?.view && (
              <Tabs.TabPane tab="Vehiculos" key={TABS.VEHICULOS} forceRender>
                <TableAddConsiderado
                  get={getVehiculos}
                  callback={getOnFinish}
                  permission={vehiculosPermission}
                  propName="vehiculo"
                  columns={VehiculoColumns}
                  ciudadano={ciudadano}
                  filterProp="propietario"
                />
              </Tabs.TabPane>
            )}
            {prediosPermission?.view && (
              <Tabs.TabPane tab="Predios" key={TABS.PREDIOS} forceRender>
                {prediosColumns?.length ? (
                  <TableAddConsiderado
                    get={getPredios}
                    callback={getOnFinish}
                    permission={prediosPermission}
                    propName="predio"
                    columns={prediosColumns}
                    ciudadano={ciudadano}
                    filterProp="ciudadano"
                  />
                ) : (
                  <Result
                    title="Se requiere la configuración de llaves de predios"
                    extra={hasPermissionClavesDePredios ? (
                      <Button onClick={() => history.push('/configuracion/entidad?tab=llavesDePredios')}>
                        Ir a Configuración de llaves de predios
                      </Button>
                    ) : null}
                  />
                )}
              </Tabs.TabPane>
            )}
          </Tabs>
        </Card>
      )}
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => {
          setVisibleAlert(false);
          setSelectedRowKeys([]);
        }}
        visible={visibleAlert}
        content=" el registro seleccionado?"
        loading={loading}
      />
    </Spin>
  );
};

Considerados.propTypes = {
  ciudadano: PropTypes.number,
};

Considerados.defaultProps = {
  ciudadano: null,
};

const Result = styled(AntResult)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default Considerados;
